import './App.css';
import Navbar from './components/Navbar';
import Main from './components/Main';
import Footer from './components/Footer';

function App() {
  return (
    <>
    <Navbar />
    <Main />
    <Footer />
    </>

    
    
  );
}

export default App;
